import { jsx as t, jsxs as c } from "react/jsx-runtime";
import * as m from "react";
import { memo as h } from "react";
import { Form as u, Input as p, Select as g, Button as i } from "antd";
import { R as v } from "./SearchOutlined-DfPPsqa8.js";
import { I as b } from "./AntdIcon-D8iup6xj.js";
var I = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M511.4 124C290.5 124.3 112 303 112 523.9c0 128 60.2 242 153.8 315.2l-37.5 48c-4.1 5.3-.3 13 6.3 12.9l167-.8c5.2 0 9-4.9 7.7-9.9L369.8 727a8 8 0 00-14.1-3L315 776.1c-10.2-8-20-16.7-29.3-26a318.64 318.64 0 01-68.6-101.7C200.4 609 192 567.1 192 523.9s8.4-85.1 25.1-124.5c16.1-38.1 39.2-72.3 68.6-101.7 29.4-29.4 63.6-52.5 101.7-68.6C426.9 212.4 468.8 204 512 204s85.1 8.4 124.5 25.1c38.1 16.1 72.3 39.2 101.7 68.6 29.4 29.4 52.5 63.6 68.6 101.7 16.7 39.4 25.1 81.3 25.1 124.5s-8.4 85.1-25.1 124.5a318.64 318.64 0 01-68.6 101.7c-7.5 7.5-15.3 14.5-23.4 21.2a7.93 7.93 0 00-1.2 11.1l39.4 50.5c2.8 3.5 7.9 4.1 11.4 1.3C854.5 760.8 912 649.1 912 523.9c0-221.1-179.4-400.2-400.6-399.9z" } }] }, name: "undo", theme: "outlined" };
function r() {
  return r = Object.assign ? Object.assign.bind() : function(e) {
    for (var l = 1; l < arguments.length; l++) {
      var a = arguments[l];
      for (var n in a)
        Object.prototype.hasOwnProperty.call(a, n) && (e[n] = a[n]);
    }
    return e;
  }, r.apply(this, arguments);
}
const O = (e, l) => /* @__PURE__ */ m.createElement(b, r({}, e, {
  ref: l,
  icon: I
})), f = /* @__PURE__ */ m.forwardRef(O);
process.env.NODE_ENV !== "production" && (f.displayName = "UndoOutlined");
const { Item: s } = u, d = "at-grid at-grid-cols-2 md:at-grid-cols-3 at-gap-x-4", y = ({
  formProps: e,
  renderAfter: l,
  wrapperClassName: a,
  hideInclude: n = !1
}) => {
  const o = e == null ? void 0 : e.form;
  return /* @__PURE__ */ t("div", { className: "at-mb-2", children: /* @__PURE__ */ c(u, { layout: "vertical", ...e, children: [
    /* @__PURE__ */ c(
      "div",
      {
        className: a || d,
        children: [
          /* @__PURE__ */ t(s, { name: "search", label: "關鍵字搜尋", children: /* @__PURE__ */ t(
            p,
            {
              placeholder: "可以輸入用戶ID, 帳號, Email, 顯示名稱",
              allowClear: !0
            }
          ) }),
          !n && /* @__PURE__ */ t(s, { name: "include", label: "包含指定用戶", className: "at-col-span-2", children: /* @__PURE__ */ t(g, { mode: "tags", placeholder: "輸入用戶 ID", allowClear: !0 }) }),
          l
        ]
      }
    ),
    /* @__PURE__ */ c(
      "div",
      {
        className: a || d,
        children: [
          /* @__PURE__ */ t(
            i,
            {
              htmlType: "submit",
              type: "primary",
              className: "at-w-full",
              icon: /* @__PURE__ */ t(v, {}),
              children: "篩選"
            }
          ),
          /* @__PURE__ */ t(
            i,
            {
              type: "default",
              className: "at-w-full",
              onClick: () => {
                o.resetFields(), o.submit();
              },
              icon: /* @__PURE__ */ t(f, {}),
              children: "重置"
            }
          )
        ]
      }
    )
  ] }) });
}, j = h(
  y
);
export {
  f as R,
  j as U
};
